import type { ReactNode } from 'react'
import { classes } from 'src/utils'

type Props = {
  children: ReactNode
  className?: string
}

export function StickyFooter(props: Props) {
  return (
    <div className="sticky bottom-0 flex flex-col w-full col-span-full">
      <div className="h-8 bg-gradient-to-t from-white" />

      <div
        className={classes(
          'flex flex-row items-center justify-start h-20 bg-white',
          props.className,
        )}
      >
        {props.children}
      </div>
    </div>
  )
}
